export const stockConstants = {
  ALL_STOCK: 'ALL_STOCK',
  RESET: 'RESET',
};
